import React, { Component, useState } from 'react';
import './imagemanagement.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faCheck, faTimes, faEye } from '@fortawesome/free-solid-svg-icons';
import { Input, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap';
import imageCompression from 'browser-image-compression';
import { getLoggedInUser } from '../../Authentication';
import { showNotification } from '../../StatusNotification';
import { showConfirmation } from '../../ConfirmationModal';

export class ImageManagement extends Component {
    static displayName = ImageManagement.name;

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            editModal: false,
            imagePreview: null,
            imageDescription: null,
            editImageDescription: null,
            imageBlob: null,
            images: null,
            search: null,
            height: null,
            width: null,
            preCompression: null,
            postCompression: null,
            compressionSavings: null,
            editImageUrl: null,
            editImageId: null,
            loggedInUser: null,
            selectedImages: [],
            selectAll: false
        };

        this.toggle = this.toggle.bind(this);
        this.editToggle = this.editToggle.bind(this);
        this.handleImageUpload = this.handleImageUpload.bind(this);
        this.uploadImage = this.uploadImage.bind(this);
        this.handleImageDescriptionChange = this.handleImageDescriptionChange.bind(this);
        this.handleEditImageDescriptionChange = this.handleEditImageDescriptionChange.bind(this);
        this.loadImages = this.loadImages.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.onPreviewLoad = this.onPreviewLoad.bind(this);
        this.editImage = this.editImage.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
        this.toggleImageSelection = this.toggleImageSelection.bind(this);
        this.toggleSelectAll = this.toggleSelectAll.bind(this);
        this.deleteSelectedImages = this.deleteSelectedImages.bind(this);
    }

    onPreviewLoad(e) {
        var img = e.target;
        var height = img.naturalHeight;
        var width = img.naturalWidth;
        console.log("Height: " + height + " Width: " + width);
        this.setState({
            height: height,
            width: width
        });
    }

    editToggle(e) {
        var idUndefined = e.id === undefined;
        if (!idUndefined) {
            this.setState({
                editModal: !this.state.editModal,
                editImageDescription: e.imageDescription,
                editImageUrl: "images/" + e.imageUrl,
                editImageId: e.id
            })
        }
        else {
            this.setState({
                editModal: !this.state.editModal,
                editImageDescription: null,
                editImageUrl: null,
                editImageId: null
            })
        }
        
    }

    async editImage(e) {
        await fetch("ImageUpload/EditImage", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                Id: this.state.editImageId,
                ImageDescription: this.state.editImageDescription
            })
        });
        this.editToggle(this);
        this.loadImages();
    }

    async deleteImage(e) {
        if (await showConfirmation("Are you sure you want to delete this image?")) {
            await fetch("ImageUpload/DeleteImage", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    Id: this.state.editImageId,
                    ImageDescription: this.state.editImageDescription
                })
            });
            this.editToggle(this);
            this.loadImages();
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
            imagePreview: null,
            imageDescription: null,
            imageBlob: null,
            height: null,
            width: null,
            preCompression: null,
            postCompression: null,
            compressionSavings: null
        });
    }

    async uploadImage() {
        if (this.state.imagePreview == null) {
            showNotification("You must upload an image.", "error");
            return false;
        }
        else if (this.state.imageDescription == null) {
            showNotification("You must provide an image description.", "error");
            return false;
        }

        let imageName = this.state.imageBlob.name;
        if (imageName.includes(";") || imageName.includes("/") || imageName.includes("?") ||
            imageName.includes(":") || imageName.includes("@") || imageName.includes("&") ||
            imageName.includes("=") || imageName.includes("+") || imageName.includes("$") || imageName.includes(",")) {

            showNotification('File name can not include the characters ";" | "/" | "?" | ":" | "@" | "&" | "=" | "+" | "$" | ","', "error");
            return false;
        }

        const formData = new FormData();
        formData.append('ImageDescription', this.state.imageDescription);
        formData.append('Image', this.state.imageBlob);
        formData.append('ImageName', imageName);

        var response = await fetch('ImageUpload/ImageUpload',
            {
                method: 'POST',
                body: formData
            }
        );

        console.log(response);
        this.toggle();
        this.loadImages();
    }

    async loadImages() {
        var response = await fetch('ImageUpload/RetrieveAll', {
            method: 'POST'
        });
        var images = await response.json();
        this.setState({
            images: images
        });
        console.log(images);
    }

    handleImageDescriptionChange(e) {
        this.setState({
            imageDescription: e.target.value
        });
    }

    handleEditImageDescriptionChange(e) {
        this.setState({
            editImageDescription: e.target.value
        });
    }

    async handleSearchChange(e) {
        await this.setState({
            search: e.target.value
        });

        if (this.state.search != null) {
            if (this.state.search.length > 2) {
                this.setState({
                    images: this.state.images.filter(u => u.imageDescription.toLowerCase().includes(this.state.search.toLowerCase()))
                });
            }
            else if (this.state.search == 0) {
                this.loadImages();
            }
        }
    }

    componentDidMount() {
        if (this.state.images == null) {
            this.loadImages();
        }
        this.getComponentData();
    }

    async handleImageUpload(event) {
        const imageFile = event.target.files[0];
        console.log('originalFile instanceof Blob', imageFile instanceof Blob); // true
        console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);
        console.log(imageFile);
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        }
        try {
            const compressedFile = await imageCompression(imageFile, options);
            console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
            console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
            console.log(compressedFile);
            var preComp = (imageFile.size / 1024).toFixed(2);
            var postComp = (compressedFile.size / 1024).toFixed(2);
            this.setState({
                imageBlob: compressedFile,
                imagePreview: window.URL.createObjectURL(compressedFile),
                preCompression: `${preComp} KB`,
                postCompression: `${postComp} KB`,
                compressionSavings: `Saved ${(preComp - postComp).toFixed(2)} KB (${((preComp - postComp) / preComp * 100).toFixed(2)}%)`
            });

            //await uploadToServer(compressedFile); // write your own logic
        } catch (error) {
            console.log(error);
        }

    }

    toggleImageSelection(imageId) {
        const selectedImages = [...this.state.selectedImages];
        const index = selectedImages.indexOf(imageId);
        
        if (index > -1) {
            selectedImages.splice(index, 1);
        } else {
            selectedImages.push(imageId);
        }
        
        this.setState({ 
            selectedImages,
            selectAll: selectedImages.length === this.state.images.length
        });
    }

    toggleSelectAll() {
        const selectAll = !this.state.selectAll;
        const selectedImages = selectAll ? this.state.images.map(img => img.id) : [];
        
        this.setState({ selectedImages, selectAll });
    }

    async deleteSelectedImages() {
        if (this.state.selectedImages.length === 0) {
            showNotification('Please select images to delete', "error");
            return;
        }

        const deleteCount = this.state.selectedImages.length;
        if (!await showConfirmation(`Are you sure you want to delete ${deleteCount} selected images?`)) {
            return;
        }

        try {
            let successCount = 0;
            for (const imageId of this.state.selectedImages) {
                const response = await fetch('ImageUpload/DeleteImage', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ 
                        Id: imageId,
                        ImageDescription: '' // Required by the API but not used for deletion
                    })
                });
                
                if (response.ok) {
                    successCount++;
                }
            }
            
            // Reload images and clear selection
            await this.loadImages();
            this.setState({ selectedImages: [], selectAll: false });
            showNotification(`Successfully deleted ${successCount} images`, "success");
        } catch (error) {
            console.error('Error deleting images:', error);
            showNotification('Error occurred while deleting images', "error");
        }
    }

    render() {
        let imagePreview = this.state.imagePreview != null ? <div><hr /><img onLoad={this.onPreviewLoad} id="preview" style={{ maxWidth: "100%", maxHeight: "300px" }} src={this.state.imagePreview} alt="Image preview" /></div> : null;
        let imageStats;
        let imageTypes = null;
        let search;
        let images;
        let logoColor = this.state.height == 200 && this.state.width == 289 ? 'primary' : 'disabled';
        let slideshowColor = this.state.height == 388 && this.state.width == 701 ? 'primary' : 'disabled';

        if (imagePreview != null) {
            imageStats = <div><hr />Image Information<br />Height: {this.state.height} Width : {this.state.width}<br />Raw Image Size: {this.state.preCompression}<br />Compressed Image Size: {this.state.postCompression}<br /><Alert color="success">{this.state.compressionSavings}</Alert></div>
            imageTypes = <div><hr /><Label>Image Type Matches</Label><br /><Button color="primary">General</Button><Button title="Image must have a height of 200px and width of 289px" color={logoColor}>Logo</Button><Button color={slideshowColor}>Slideshow</Button></div>

        }

        if (this.state.images != null) {
            search = <>
                <label htmlFor="image-search" className="sr-only">Search images</label>
                <Input id="image-search" type="text" value={this.state.search} onChange={this.handleSearchChange} placeholder="Enter 3 or more characters to search images.." />
            </>;
            
            const hasSelection = this.state.selectedImages.length > 0;
            const disabled = this.state.loggedInUser?.role !== "Admin";
            
            images = (
                <div>
                    <div className="image-controls">
                        <div className="selection-controls">
                            <Input
                                id="image-selectAll"
                                type="checkbox"
                                checked={this.state.selectAll}
                                onChange={this.toggleSelectAll}
                                disabled={disabled}
                            />
                            <Label htmlFor="image-selectAll">Select All</Label>
                            {hasSelection && (
                                <Button 
                                    color="danger" 
                                    size="sm" 
                                    onClick={this.deleteSelectedImages}
                                    disabled={disabled}
                                    className="ml-3"
                                >
                                    Delete Selected ({this.state.selectedImages.length})
                                </Button>
                            )}
                        </div>
                    </div>
                    <div className="images-grid">
                        {this.state.images.map(image => {
                            const imgSrc = "images/" + image.imageUrl;
                            const isSelected = this.state.selectedImages.includes(image.id);
                            
                            return (
                                <div key={image.id} className={`image-item ${isSelected ? 'selected' : ''}`}>
                                    <div className="image-checkbox">
                                        <Input 
                                            type="checkbox" 
                                            checked={isSelected}
                                            onChange={() => this.toggleImageSelection(image.id)}
                                            onClick={(e) => e.stopPropagation()}
                                            disabled={disabled}
                                        />
                                    </div>
                                    <div 
                                        className="image-content" 
                                        onClick={() => this.editToggle(image)}
                                    >
                                        <div className="image-container-top">
                                            <img src={imgSrc} alt={image.imageDescription} />
                                        </div>
                                        <div className="image-description">
                                            {image.imageDescription}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        }

        let imageField = this.state.imageBlob == null ?
            <input id="image-upload" type="file" accept="image/*" onChange={this.handleImageUpload} /> :
            <input id="image-upload" type="file" accept="image/*" onChange={this.handleImageUpload} disabled />;

        let disabled = true;
        if (this.state.loggedInUser != null) {
            disabled = this.state.loggedInUser.role != "Admin";
        }

        return (
            <div>
                <h1 className="page-title">Image Management<br />
                    <Button id="uploadImageBtn" color="success" onClick={this.toggle}>Upload Image</Button>
                </h1>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Image Upload</ModalHeader>
                    <ModalBody>
                        {imageField}
                        <br />
                        {imageStats}
                        {imagePreview}
                        {imageTypes}
                        <hr />
                        <Label htmlFor="image-description">Image Description</Label>
                        <Input id="image-description" type="text" value={this.state.imageDescription} onChange={this.handleImageDescriptionChange} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color='primary' onClick={this.uploadImage}>Upload</Button>{' '}
                        <Button color='secondary' onClick={this.toggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.editModal} toggle={this.editToggle} className={this.props.className}>
                    <ModalHeader toggle={this.editToggle}>Image Update</ModalHeader>
                    <ModalBody>
                        <img style={{maxWidth:'450px'}} src={this.state.editImageUrl} alt="Edit image preview" />
                        <br />
                        <hr />
                        <Label htmlFor="image-editDescription">Image Description</Label>
                        <Input id="image-editDescription" type="text" value={this.state.editImageDescription} onChange={this.handleEditImageDescriptionChange} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color='primary' disabled={disabled} onClick={this.editImage}>Update</Button>{' '}
                        <Button color='danger' disabled={disabled} onClick={this.deleteImage}>Delete</Button>{' '}
                        <Button color='secondary' onClick={this.editToggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                {search}
                {images}
            </div>
        );
    }

    async getComponentData() {
        let loggedInUser = await getLoggedInUser();
        if (loggedInUser != null) loggedInUser = JSON.parse(loggedInUser);

        this.setState({
            loggedInUser: loggedInUser
        });
    }
}